import { MaybeRef } from '@vueuse/core'
import { unref } from 'vue'

type UseDestinationReturn = {
  selectionNotNull: (
    selection: MaybeRef<{ name: string; type: string; number?: number } | null>
  ) => boolean
  notBothHome: () => boolean
  storesDifferent: () => boolean
  all: () => boolean
}
export const useDestinationRules = (data: {
  departing: MaybeRef<{ name: string; type: string; number?: number } | null>
  destination: MaybeRef<{ name: string; type: string; number?: number } | null>
}): UseDestinationReturn => {
  const selectionNotNull = (
    selection: MaybeRef<{ name: string; type: string; number?: number } | null>
  ) => {
    if (unref(selection) == null) return false
    return true
  }
  const selectionsNotNull = () => {
    if (unref(data.departing) == null || unref(data.destination) == null) return false
    return true
  }
  const notBothHome = () => {
    if (
      selectionsNotNull() &&
      unref(data.departing)!.type === 'home' &&
      unref(data.destination)!.type === 'home'
    )
      return false
    return true
  }

  const storesDifferent = () => {
    if (
      selectionsNotNull() &&
      unref(data.departing)!.type === 'store' &&
      unref(data.destination)!.type === 'store'
    ) {
      if (
        unref(data.departing) &&
        unref(data.destination) &&
        `${unref(data.departing)!.name} #${unref(data.departing)!.number}` !==
          `${unref(data.destination)!.name} #${unref(data.destination)!.number}`
      ) {
        return true
      } else {
        return false
      }
    }
    return true
  }

  const all = () => {
    return selectionsNotNull() && notBothHome() && storesDifferent()
  }
  return {
    selectionNotNull,
    notBothHome,
    storesDifferent,
    all,
  }
}
